<template>
    <div>
        <v-row>
            <v-col>
                <vc-date-picker
                    :attributes="[{ key: 'today', highlight: { color: 'orange', fillMode: 'solid', class: 'primary' }, dates: new Date() }]"
                    :popover="{ visibility: 'focus' }" :value="$moment(value.time).format('DD-MM-YYYY HH:mm')"
                    @input="val => timeChanged(val)" mode="dateTime" is24hr
                    :model-config="{ type: 'string', mask: 'DD-MM-YYYY HH:mm' }">
                    <template v-slot="{ inputValue, inputEvents, updateValue }">
                        <eod-text-field class="mb-4" hide-details label="Van" prepend-icon="mdi-calendar" :value="inputValue"
                            @input="updateValue($event, { formatInput: false, hidePopover: false, debounce: 1000 })"
                            @change="updateValue($event, { formatInput: true, hidePopover: false, })" v-on="inputEvents"
                            dense outlined clearable :disabled="isReadonly"></eod-text-field>
                    </template>
                </vc-date-picker>
                <vc-date-picker
                    :attributes="[{ key: 'today', highlight: { color: 'orange', fillMode: 'solid', class: 'primary' }, dates: new Date() }]"
                    :popover="{ visibility: 'focus' }"
                    :value="value.duration ? $moment((parseInt($moment(value.time).unix()) + value.duration) * 1000).format('DD-MM-YYYY HH:mm') : null"
                    @input="val => durationChanged(val)" mode="dateTime" is24hr
                    :model-config="{ type: 'string', mask: 'DD-MM-YYYY HH:mm' }">
                    <template v-slot="{ inputValue, inputEvents, updateValue }">
                        <eod-text-field class="mb-4" hide-details label="Tot" prepend-icon="mdi-calendar" :value="inputValue"
                            @input="updateValue($event, { formatInput: false, hidePopover: false, debounce: 1000 })"
                            @change="updateValue($event, { formatInput: true, hidePopover: false, })" v-on="inputEvents"
                            dense outlined clearable :disabled="isReadonly"></eod-text-field>
                    </template>
                </vc-date-picker>
                <div class="d-flex align-center mb-4">
                    <v-avatar class="mr-2 ml-1" size="21" v-if="value.id && value.severity" :color="Event.getSeverity(value.severity).color"></v-avatar>
                    <eod-text-field hide-details outlined dense v-if="value.id" label="Waarde" :value="valueItems && valueItems[value.value]?valueItems[value.value].name:value.value" disabled :suffix="unitFields?unitFields.Symbol:null"></eod-text-field>                    
                </div>
                <eod-list-item-autocomplete
                    v-if="$eod.getOrganizationSetting('events.categories.listId') && $eod.getOrganizationSetting('events.categories.listId').value"
                    class="mb-4" label="Categorie" :listId="$eod.getOrganizationSetting('events.categories.listId').value"
                    return-object v-model="value.category" dense outlined :disabled="isReadonly"></eod-list-item-autocomplete>
                <div class="primary px-2 py-1 rounded white--text"><v-icon dark
                        left>mdi-comment-processing-outline</v-icon>Bericht*</div>
                <eod-textarea outlined v-model="isReadonly?value.messageFormatted:value.message" hide-details required class="mb-4" :disabled="isReadonly"></eod-textarea>
                <v-alert color="error" dark dense text v-if="errors.message">{{ errors.message }}</v-alert>
            </v-col>
            <v-col cols="auto">
                <div class="grey lighten-3 px-4 py-4 text-caption rounded-lg mb-4"
                    style="width:350px;">
                    <div class="d-flex justify-content-between">
                        <span class="text-subtitle-1">Info</span>
                        <v-btn v-if="!infoAdvanced && !isReadonly" @click="addEventsDialogEditInfo" small icon><v-icon small
                                left>mdi-pencil-outline</v-icon></v-btn>
                    </div>
                    <template v-if="infoAdvanced">
                        <eod-item-treeview-selector v-model="companyProject" outlined label="Project*"
                            :tree="['companies', 'projects']"
                            :fields="[['id', 'name', 'description'], ['id', 'name', 'description']]"
                            :modules="settings.modules" @input="projectsChanged" :disabled="isReadonly"></eod-item-treeview-selector>
                        <v-alert color="error" dark dense text v-if="errors.projectId">{{ errors.projectId }}</v-alert>
                        <v-card outlined class="mt-2">
                            <v-card-text>
                                <div class="mt-4 mb-4">
                                    <eod-objects-treeview-input :disabled="isReadonly" label="Asset" :value="value.product?value.product.id:null" @input="val => val?value.product={id:val}:null"></eod-objects-treeview-input>
                                </div>
                                <eod-user-selector class="mt-4" label="Databron" v-model="value.owner" return-object dense
                                    outlined :disabled="isReadonly">
                                </eod-user-selector>
                                <eod-user-selector class="mt-4" label="Gebruiker" v-model="value.responsibleUser"
                                    return-object dense outlined :disabled="isReadonly">
                                </eod-user-selector>
                                <eod-object-autocomplete class="mt-4" endpoint="measurementTypes" label="Type meetwaarde"
                                    :value="value.measurementType"
                                    :fields="['id', 'name', 'unit{id name fields{name description}}']"
                                    @input="val => updateEventProperty('measurementType', val)" return-object dense
                                    outlined :disabled="isReadonly"></eod-object-autocomplete>
                            </v-card-text>
                        </v-card>
                    </template>
                    <template v-else>
                        <div v-if="value.project">Project: <strong>{{ value.project.name
                        }}</strong></div>
                        <div v-if="value.company">Bedrijf: <strong>{{ value.company.name
                        }}</strong></div>
                        <div v-if="value.product">Asset: <strong>{{ value.product.name
                        }}</strong></div>
                        <div v-if="value.owner">Databron: <strong>{{
                            value.owner.getFullName()
                        }}</strong></div>
                        <div v-if="value.responsibleUser && value.responsibleUser.getFullName">Gebruiker: <strong>{{
                            value.responsibleUser.getFullName()
                        }}</strong></div>
                        <div v-if="value.measurementType">Type meetwaarde: <strong>{{
                            value.measurementType.name
                        }}</strong></div>
                    </template>
                </div>
                <v-btn block depressed rounded v-if="value.id && $eod.getUser().can('tasks.workflows.create') && !readonly" @click="createNewTask"><v-icon small left>mdi-clipboard-plus-outline</v-icon>Nieuwe taak</v-btn>
                <template v-if="value.alarmTemplate && value.alarmTemplate.content">
                    <v-btn block depressed rounded class="mt-2" v-if="value.id && !readonly && !isEventMasked" @click="toggleMaskEvent"><v-icon small left>mdi-bell-cancel-outline</v-icon>Maskeren</v-btn>
                    <template v-if="isEventMasked">
                        <v-btn block depressed rounded class="mt-2" v-if="value.id && !readonly" @click="toggleMaskEvent" color="mask" dark><v-icon small left>mdi-bell-outline</v-icon>Maskering opheffen</v-btn>
                        <div class="py-4 px-4 my-4 grey lighten-5 rounded-lg" style="width:350px;">
                        <vc-date-picker :popover="{ visibility: 'focus' }" :minute-increment="15" :min-date='new Date()'
                            :attributes="[{ key: 'today', highlight: { color: 'orange', fillMode: 'solid', class: 'primary' }, dates: new Date() }]"
                            :value="value.alarmTemplate.content.mask_until || null" @input="changeMaskUntil"
                            mode="dateTime" is24hr
                            :model-config="{ type: 'string', mask: 'DD-MM-YYYY HH:mm' }">
                            <template v-slot="{ inputValue, inputEvents, updateValue }">
                                <v-label>Maskeren tot</v-label>
                                <eod-text-field readonly info="Laat dit veld leeg om doorlopend te maskeren tot manueel opheffen"
                                autocomplete="off"
                                @input="changeMaskUntil"
                                    prepend-icon="mdi-calendar" :value="inputValue"
                                    v-on="inputEvents" clearable></eod-text-field>
                            </template>
                        </vc-date-picker>
                        <v-alert class="mt-2" color="error" dark dense text v-if="errors.maskUntil">{{ errors.maskUntil }}</v-alert>
                        <v-alert type="info" class="mt-2" dense text>De maskering is van toepassing op de alarmregel.</v-alert>
                    </div>
                    </template>
                </template>
            </v-col>
        </v-row>
        <eod-comments :tags="{
            projectId: (value.project ? value.project.id : null),
            companyId: (value.company ? value.company.id : null),
            productId: (value.product ? value.product.id : null),
            userId: (value.owner ? value.owner.id : null),
        }" class="mb-5" dense image-field-name="storageObjects" image-objects v-model="value.comments"></eod-comments>
        <v-alert class="mt-2" color="error" dark dense text v-if="errors.comments">{{ errors.comments }}</v-alert>
        <eod-workflow-dialog v-if="isCreateNewWorkflowDialogVisible && $eod.getUser().can('tasks.workflows.create')"
                v-model="isCreateNewWorkflowDialogVisible" :workflow="createWorkflowData"
                @saved="workflowSaved"></eod-workflow-dialog>
    </div>
</template>
<script>
import eodComments from './eod-comments.vue';
import eodObjectsTreeviewInput from './eod-objects-treeview-input.vue';
import eodListItemAutocomplete from './eod-list-item-autocomplete.vue';
import eodItemTreeviewSelector from './eod-item-treeview-selector.vue';
import eodObjectAutocomplete from './eod-object-autocomplete.vue';
import eodUserSelector from './eod-user-selector.vue';
import eodWorkflowDialog from './eod-workflow-dialog.vue';
import Event from './../models/event';
import User from './../models/user';

export default {
    name: 'eod-event',
    components: {
        eodComments,
        eodListItemAutocomplete,
        eodItemTreeviewSelector,
        eodObjectAutocomplete,
        eodUserSelector,
        eodObjectsTreeviewInput,
        eodWorkflowDialog,
    },
    props: {
        value: Object,
        readonly: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            settings: require('./../classes/settings'),
            companyProject: [],
            infoAdvanced: false,
            errors: {},
            isReadonly: false,
            isEventMasked: false,
            valueItems: null,
            unitFields: null,
            Event: Event,
            isCreateNewWorkflowDialogVisible: false,
            createWorkflowData: null
        }
    },
    mounted() {
        if (this.value.id) {
            this.loadEvent();
        }
    },
    methods: {
        async toggleMaskEvent(){
            const val = this.value;

            this.isEventMasked = !this.isEventMasked;

            if(val.status != 'cleared'){
                val.isMasked = this.isEventMasked;
            }

            if(val.alarmTemplate && val.alarmTemplate.content){
                val.alarmTemplate.content.is_masked = this.isEventMasked;
            }
            
            this.$emit('input', val);
        },
        async changeMaskUntil(datetime){
            const val = this.value;
            
            if(val.alarmTemplate && val.alarmTemplate.content){
                if(datetime){
                    val.alarmTemplate.content.mask_until = this.$moment(datetime, 'DD-MM-YYYY HH:mm').format('YYYY-MM-DD HH:mm');
                }else {
                    val.alarmTemplate.content.mask_until = null;
                }
            }
            this.$emit('input', val);
        },
        createNewTask(){
            const defaultWorkflow = this.$eod.getOrganizationSetting('tasks.taskType.default.portal');
            let taskTypeId = null;
            if(defaultWorkflow && defaultWorkflow.value){
                taskTypeId = defaultWorkflow.value;
            }

            const valueItems = this.$eod.getMeasurementTypeItems(this.value.measurementType);
            let measurementTypeVal = '';
            if(this.value.value && valueItems[this.value.value]){
                measurementTypeVal = ': ' + valueItems[this.value.value].name;
            } else if (this.value.value){
                measurementTypeVal = ': ' + this.value.value;
            }

            let productVal = '';
            if(this.value.product){
                productVal += ' | ' + this.value.product.name;
            }

            let ownerVal = '';
            if(this.value.owner){
                ownerVal += ' | ' + this.value.owner.getFullName();
            }

            //niveau alarm : meetaarde : waarde toestel (bvb. Kritiek : Vacuüm : 324.3181 Vacuümsensor 1)
            const name = this.value.measurementType.name + measurementTypeVal + productVal + ownerVal + ' | '+this.$moment(this.value.time).format('DD/MM/YYYY HH:mm');

            this.createWorkflowData = {
                companyId: this.value.project.company.id,
                projectId: this.value.project.id,
                taskTypeId: taskTypeId,
                serviceId: this.value.project.company.defaultService.id,
                name: name
            };

            this.isCreateNewWorkflowDialogVisible = true;
        },
        workflowSaved(){
            this.isCreateNewWorkflowDialogVisible = false;
        },
        validate() {
            const data = (new Event(this.value)).getSaveData();

            this.errors = {};

            if (!(data.message && data.message != '')) {
                this.errors.message = 'Bericht is verplicht!';
            }

            if (!data.projectId) {
                this.errors.projectId = 'Project is verplicht!';
                this.infoAdvanced = true;
            }

            if (!data.companyId) {
                this.errors.companyId = 'Bedrijf is verplicht!';
                this.infoAdvanced = true;
            }

            if(this.isEventMasked){
                if(!(data.comments && data.comments[0])){
                    this.errors.comments = 'Voeg een opmerking toe waarom u het alarm maskeert.'
                }

                if(this.value.alarmTemplate.content.mask_until && !this.$moment(this.value.alarmTemplate.content.mask_until, 'YYYY-MM-DD HH:mm').isAfter(this.$moment())){
                    this.errors.maskUntil = 'Datum moet in de toekomst liggen!';
                }
            }

            if (Object.keys(this.errors).length > 0) {
                return false;
            }

            return true;
        },
        getMeasurementTypeInfo(measurementType){
            this.valueItems = this.$eod.getMeasurementTypeItems(measurementType);
            this.unitFields = this.$eod.getMeasurementTypeUnitFields(measurementType);
        },
        loadEvent() {
            this.$eod.getById('event', this.value.id, ['id', 'message', 'value', 'time', 'alarmTemplate{id content}', 'duration', 'category{id name}', 'eventGroupUnique', 'project{id name company{id name defaultService{id}}}', 'owner{id}', 'responsibleUser{id}', 'product{id name}', 'measurementType{id, name unit{id name fields{name description} list{fields{name}}} valueConfigList{id name description itemType fields{name description isActive} listItems{id name description low high threshold stepSize color fields{name description isActive}}} valueConfigListItems{id name description low high threshold stepSize color fields{name description isActive}}}', 'comments{content, createdAt, userId, storageObjects{id key name}, organizationId}', 'severity', 'status', 'userStatus', 'type', 'facility'])
                .then(async response => {
                    if (response.data.data.event) {
                        const event = response.data.data.event;

                        if(event.alarmTemplate && event.alarmTemplate.content){
                            this.isEventMasked = event.alarmTemplate.content.is_masked?true:false;
                        }

                        if(event.facility && event.facility != 'user'){
                            this.isReadonly = true;
                        }

                        this.companyProject = [];
                        if (event.project && event.project.company) {
                            event.company = event.project.company;
                            this.companyProject.push(event.project.company.id);
                            this.companyProject.push(event.project);
                        } else {
                            this.infoAdvanced = true;
                        }

                        if (!event.userStatus) {
                            event.userStatus = 'unassigned';
                        }

                        if (event.owner && event.owner.id) {
                            event.owner = await this.$eod.getById('user', event.owner.id, ['id', 'firstName', 'lastName', 'username']).then(userResponse => {
                                if (userResponse.data.data.user) {
                                    return new User(userResponse.data.data.user);
                                }
                            });
                        } else {
                            event.owner = this.$eod.getUser();
                        }

                        if (event.responsibleUser && event.responsibleUser.id) {
                            event.responsibleUser = await this.$eod.getById('user', event.responsibleUser.id, ['id', 'firstName', 'lastName', 'username']).then(userResponse => {
                                if (userResponse.data.data.user) {
                                    return new User(userResponse.data.data.user);
                                }
                            });
                        }

                        this.getMeasurementTypeInfo(event.measurementType);

                        this.$emit('input', new Event(event));
                        this.$forceUpdate();
                    }
                });
        },
        addEventsDialogEditInfo() {
            this.infoAdvanced = true;
        },
        projectsChanged(val) {
            this.updateEventProperty('company', val[0]);
            this.updateEventProperty('project', val[1]);
        },
        timeChanged(val) {
            this.updateEventProperty('time', this.$moment(val, 'DD-MM-YYYY HH:mm').toISOString());
        },
        durationChanged(val) {

            if (val) {
                const start = this.$moment(this.value.time).unix();
                const end = this.$moment(val, 'DD-MM-YYYY HH:mm').unix();
                const duration = end - start;

                if (duration >= 0) {
                    this.updateEventProperty('duration', duration);
                }
            } else {
                this.updateEventProperty('duration', null);
            }

        },
        updateEventProperty(propertyName, val) {
            const value = this.value;
            value[propertyName] = val;
            this.$emit('input', value);

            this.$nextTick(this.validate);
        }
    }
}
</script>